import {
  IUpdateParentProfilePayload,
  IUpdateParentPreferencesPayload,
} from '@/types/payload';

import http from './http';
import serviceHelper from './serviceHelper';

export const getParentProfile = async () => {
  return serviceHelper(http.get('/parent'), false);
};

export const updateParentProfile = async (
  payload: IUpdateParentProfilePayload
) => {
  return serviceHelper(http.patch('/parent', payload), true);
};

export const getParentChildren = async () => {
  return serviceHelper(http.get('/parent/children'), false);
};

export const getParentPreferences = async () => {
  return serviceHelper(http.get('/parent/preferences'), false);
};

export const updateParentPreferences = async (
  payload: IUpdateParentPreferencesPayload
) => {
  return serviceHelper(http.patch('/parent/preferences', payload), true);
};

export const removeParentChild = async (id: string) => {
  return serviceHelper(http.delete(`/parent/child/${id}`), true);
};

export const getRelationshipDropdown = async () => {
  return serviceHelper(http.get('/parent/relationship-dropdown'), false);
};

export const uploadImage = async (formData: FormData) => {
  return serviceHelper(
    http.post('/upload/user/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
    false,
    true
  );
};
